import { render, staticRenderFns } from "./MemberPurchases.vue?vue&type=template&id=616fcaa2&"
import script from "./MemberPurchases.vue?vue&type=script&lang=js&"
export * from "./MemberPurchases.vue?vue&type=script&lang=js&"
import style0 from "./MemberPurchases.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports